// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/FuturaLT.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/FuturaLT-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/FuturaLT-Book.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*

* This file contains the styling for R&D Questionnaires components

This files table contents are outlined below>>>>>

*******************************************
*******************************************
*/

@font-face {
    font-family: "FuturaLT";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

@font-face {
    font-family: "FuturaLT-Bold";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
    font-weight: bold;
}

@font-face {
    font-family: "FuturaLT-Book";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

:root {
    --hsrcDarkBlue: #133454;
    --hsrcMidBlue: #415167;
    --hsrcOrange: #FF7F50;
    --hsrcYellow: hsl(41, 100%, 73%);
    --hsrcDarkYellow: hsl(43, 100%, 73%);
    --hsrcInactive: #A2A1B2;
    --hsrcLightDark: #ECEFF4;
    --hsrcHoverLight: #F8F7FE;
    --hsrcBackgroundLight: #FCFCFC;
    --hsrcWhite: #FFFFFF;
    --hsrcHover: #A17FEF;
    --hsrcMainRed: #FF3407;
    --hsrcLightRed: #FFF7F5;
    --hsrcMainGreen: #00BA88;
    --hsrcMidGreen1: #E9FBE6;
    --hsrcMidGreen2: #D7FAD1;
    --hsrcMidGreen3: #BDF1BF;
    --hsrcMidGreen: var(--hsrcMidGreen2);
    --hsrcLightGreen: #F6FFF9;
    --hsrcBlue: #669FF6;
    --hsrcPurple: #7381EA;
    --FontFamily: FuturaLT;
    --boldFontFamily: FuturaLT-Bold;
    --bookFontFamily: FuturaLT-Book;
    --st-modal-borderRadius: 15 px;
    --st-modal-boxShadow: 0 10px 50px rgba(0, 0, 0, 0.8);
    --st-modal-backgroundColor: var(--hsrcWhite);
    --st-modal-titleTextColor: var(--hsrcMidBlue);
    --st-modal-secondColor: var(--hsrcWhite);
    --st-dialog-contentColor: var(--hsrcDarkBlue);
    --st-modal-transformVisible: translate3d(-50%, -50%, 0) scale(1);
    --st-modal-transformHidden: translate3d(-50%, -50%, 0) scale(0.1);
    --st-button-primaryColor: var(--hsrcOrange);
    --st-button-primaryTextColor: var(--hsrcWhite);
}

html,
body {
    font-family: var(--FontFamily);
    color: var(--hsrcMidBlue);
    height: 100vh;
}

/* a:link{
color: var(--hsrcOrange);
} */

::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    font-family: var(--FontFamily);
    color: var(--hsrcInactive);
}

::-moz-placeholder {
    /* Firefox 19+ */
    font-family: var(--FontFamily);
    color: var(--hsrcInactive);
}

:-ms-input-placeholder {
    /* IE 10+ */
    font-family: var(--FontFamily);
    color: var(--hsrcInactive);
}

:-moz-placeholder {
    /* Firefox 18- */
    font-family: var(--FontFamily);
    color: var(--hsrcInactive);
}

.title__54px {
    font-size: 54px;
    color: var(--hsrcDarkBlue);
    letter-spacing: 0.07em;
    text-transform: none;
}

.title__54px__orange {
    font-size: 54px;
    color: var(--hsrcOrange);
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
    letter-spacing: 0.07em;
    text-transform: capitalize;
}

.title__42px {
    font-size: 42px;
    color: var(--hsrcDarkBlue);
    letter-spacing: 0.07em;
    text-transform: capitalize;
}

.title__42px__orange {
    color: var(--hsrcOrange);
    font-size: 42px;
    letter-spacing: 0.07em;
    text-transform: capitalize;
}

.title__42px__orange__bold {
    font-family: var(--FontFamily);
    font-style: normal;
    color: var(--hsrcOrange);
    font-size: 42px;
    font-weight: bold;
    letter-spacing: 0.07em;
    text-transform: capitalize;
}

.title__66px {
    color: var(--hsrcDarkBlue);
    font-size: 66px;
    line-height: 120%;
    letter-spacing: 0.07em;
    text-transform: capitalize;
}

.title__32px {
    color: var(--hsrcDarkBlue);
    font-size: 32px;
    line-height: 42px;
    letter-spacing: 0.07em;
    text-transform: capitalize;
}

.title__32px__orange {
    color: var(--hsrcOrange);
    font-size: 32px;
    line-height: 42px;
    letter-spacing: 0.07em;
    text-transform: capitalize;
}

.title__18px {
    font-weight: bold;
    font-size: 18px;
    line-height: 200%;
    letter-spacing: 0.07em;
    text-transform: capitalize;
    color: var(--hsrcDarkBlue);
}

.title__24px {
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.07em;
    text-transform: capitalize;
    color: var(--hsrcDarkBlue);
}

.title__16px {
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.07em;
    text-transform: none;
    color: var(--hsrcDarkBlue);
}


.title__16px__instruction {
    font-size: 16px;
    font-weight: bold;
    line-height: 150%;
    letter-spacing: 0.07em;
    text-transform: capitalize;
    color: var(--hsrcDarkYellow);
    padding-left: 20px;
}


.title__16px__definition {
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.07em;
    text-transform: capitalize;
    color: var(--hsrcOrange);
}


.title__16px__bold {
    font-family: var(--FontFamily);
    font-style: normal;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.07em;
    text-transform: none;
    color: var(--hsrcDarkBlue);
    font-weight: bold;
}

.title__18px__orange {
    font-weight: bold;
    font-size: 18px;
    line-height: 200%;
    letter-spacing: 0.07em;
    text-transform: capitalize;
    color: var(--hsrcOrange);
}

.title__24px {
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.07em;
    text-transform: none;
    color: var(--hsrcDarkBlue);
}

.title__24px__orange {
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.07em;
    text-transform: capitalize;
    color: var(--hsrcOrange);
}

.title__16px__orange {
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.07em;
    text-transform: capitalize;
    color: var(--hsrcOrange);
}

.text__24px {
    font-size: 24px;
    letter-spacing: 0.07em;
    color: var(--hsrcMidBlue);
    line-height: 200%;
}

.text__18px {
    font-size: 18px;
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.07em;
    text-transform: none;
    color: var(--hsrcMidBlue);
}

.text__18px__bold {
    font-size: 18px;
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: bold;
    letter-spacing: 0.07em;
    color: var(--hsrcMidBlue);
}

.text__18px__border {
    font-size: 18px;
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.07em;
    color: var(--hsrcMidBlue);
    border: 1px;
    border-style: solid;
    border-color: var(--hsrcOrange);
    padding: 1em;
}

.text__18px__orange {
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0.07em;
    color: var(--hsrcOrange);
}

.text__18px__orange__bold {
    font-size: 18px;
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: bold;
    letter-spacing: 0.07em;
    color: var(--hsrcOrange);
}

.text__12px {
    font-size: 12px;
    color: var(--hsrcMidBlue);
}

.text__16px {
    font-family: var(--FontFamily);
    font-size: 16px;
    color: var(--hsrcDarkBlue);
}

.text__16px__border {
    font-family: var(--FontFamily);
    font-size: 16px;
    color: var(--hsrcDarkBlue);
    border: 1px;
    border-style: solid;
    border-color: var(--hsrcOrange);
    padding: 1em;
}

.text__16px__orange {
    font-family: var(--FontFamily);
    font-size: 16px;
    color: var(--hsrcOrange);
}

.text__14px {
    font-size: 14px;
    color: var(--hsrcMidBlue);
}

.text__14px__orange {
    font-size: 14px;
    color: var(--hsrcOrange);
}

.input__box {
    width: 434px;
    height: 70px;
    border-radius: 16px;
    background: var(--hsrcBackgroundLight);
    color: var(--hsrcMidBlue);
    font-size: 16px;
    border-style: solid;
    border-width: 1.5px;
    border-color: var(--hsrcMidBlue);
    padding: 20px;
    /* Safari/Chrome, other WebKit */
    /* Firefox, other Gecko */
    box-sizing: border-box;
    /* Opera/IE 8+ */
}

.button__orange {
    display: inline-block;
    border-radius: 13px;
    background-color: var(--hsrcOrange);
    border-color: var(--hsrcOrange);
    border-style: solid;
    border-width: 1.5px;
    color: var(--hsrcWhite);
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    padding-left: 15px;
    padding-right: 15px;
    transition: all 0.5s;
    margin: 15px;
    letter-spacing: 0.08rem;
    cursor: pointer;
    height: 70px;
    width: auto;
}

.button {
    display: inline-block;
    border-radius: 13px;
    background-color: var(--hsrcBackgroundLight);
    border-style: solid;
    border-width: 1.5px;
    border-color: var(--hsrcDarkBlue);
    color: var(--hsrcDarkBlue);
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    padding-left: 15px;
    padding-right: 15px;

    transition: all 0.5s;
    margin: 15px;
    letter-spacing: 0.08rem;
    cursor: pointer;
    height: 70px;
    width: auto;
}

a:link {
    text-decoration: none;
    font-family: var(--bookFontFamily);
    color: var(--hsrcMidBlue);
}

a:visited {
    text-decoration: none;
    color: var(--hsrcMidBlue);
}

a:hover {
    text-decoration: none;
    font-family: var(--bookFontFamily);
    color: var(--hsrcOrange);
}

a:active {
    text-decoration: none;
}

.btnNext {
    background-color: var(--hsrcYellow);
    /* Green */
    border: none;
    color: black;
    font-size: 24px;
    padding: 20px;
    width: 200px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 15px 20px;
    cursor: pointer;
    border-radius: 8px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.btnBack {
    background-color: var( --hsrcDarkBlue);
    font-size: 24px;
    padding: 20px;
    width: 200px;
    border: none;
    color: var(--hsrcWhite);
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 15px 20px;
    cursor: pointer;
    border-radius: 8px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.btnBack2 {
    background-color: var( --hsrcDarkBlue);
    font-size: 12px;
    /* padding: 5px; */
    min-width: 6rem;
    border-radius: 0.5rem;
    font-size: 0.8em;
    min-height: 2rem;
    border: none;
    color: var(--hsrcWhite);
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 5px 8px;
    cursor: pointer;
    /* border-radius: 12px; */
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.btnFinish {
    background-color: var(--hsrcYellow);
    font-size: 24px;
    padding: 20px;
    width: 200px;
    border: none;
    color: black;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 15px 20px;
    cursor: pointer;
    border-radius: 8px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.question {
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0.07em;
    text-align: left;
}

.belowTitleText {
    font-family: var(--bookFontFamily);
    color: var(--hsrcMidBlue);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
    letter-spacing: 0.07em;
    text-align: left;
}

.partNumber {
    font-family: var(--bookFontFamily);
    color: var(--hsrcDarkBlue);
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: 63px;
    letter-spacing: 0.07em;
    text-align: left;
}

.partTitle {
    font-family: var(--bookFontFamily);
    font-size: 25px;
    line-height: 63px;
    letter-spacing: 0.07em;
    text-align: left;
}

.pageHint {
    font-family: var(--bookFontFamily);
    margin-left: 30px;
    font-size: 12px;
    white-space: pre-wrap ; 
}

.pageHint .pageHintText {
    font-family: var(--bookFontFamily);
    font-size: 12px;
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: var(--hsrcWhite);
    text-align: left;
    padding: 5px 0;
    border-radius: 6px;
    white-space: pre-wrap ; 

}

/* Tooltip text */

.pageHint .tooltiptext {
    visibility: hidden;
    width: 20%;
    background-color: var(--hsrcLightRed);
    color: var(--hsrcMainRed);
    text-align:left;
    margin-left: 20px;
    padding: 10px;
    border: 1px solid var(--hsrcMainRed);
    box-sizing: border-box;
    border-radius: 5px;
    
    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 1; 

}


/* Show the tooltip text when you mouse over the tooltip container */

.pageHint:hover .tooltiptext {
    visibility: visible;
}

.inputRandSign {
    position: start;
    text-align: left;
    align-content: center;
}

.input-text--rounded-corners {
    font-family: var(--bookFontFamily);
    border-radius: 15px;
    border: 0.5px solid;
    background: var(--hsrcBackgroundLight);
    color: var(--hsrcMidBlue);
    font-size: 16px;
    border-style: solid;
    border-width: 1.5px;
    border-color: var(--hsrcMidBlue);
}

input.radio {
    width: 16px;
    height: 16px;
    margin: 10px;
}

input[type="radio"]:checked+label {
    font-family: Futura LT;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
    letter-spacing: 0.07em;
    text-align: left;
}

input[type='radio']:after {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    top: -2px;
    left: -1px;
    position: relative;
    background-color: #d1d3d1;
    content: '';
    display: inline-block;
    visibility: visible;
    border: 2px solid white;
}

input[type='radio']:checked:after {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    top: -2px;
    left: -1px;
    position: relative;
    content: '';
    display: inline-block;
    visibility: visible;
    border: 4px solid #07BC85;
}

.b2 {
    width: 800px;
}

h2 {
    font-family: var(--bookFontFamily);
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 0.07em;
    text-align: left;
}

h5 {
    font-family: var(--bookFontFamily);
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 0.07em;
    text-align: left;
}

input[type='text'] {
    border-style: none none solid none;
    border-collapse: collapse;
    border-radius: 0px;
    border-color: var(--hsrcInactive);
    width: 100%;
    height: 100%;
}

input[type='number'] {
    border-style: none;
    border-collapse: collapse;
    border-radius: 0px;
    border-color: var(--hsrcWhite);
    width: 100px;
    height: 100%;
}

input[type='radio']:after {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    top: -2px;
    left: -1px;
    position: relative;
    background-color: var(--hsrcBackgroundLight);
    content: '';
    display: inline-block;
    visibility: visible;
    border: 2px solid var(--hsrcWhite);
}

input[type='radio']:checked:after {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    top: -2px;
    left: -1px;
    position: relative;
    content: '';
    display: inline-block;
    visibility: visible;
    border: 4px solid var(--hsrcMainGreen);
}

.link {
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 1%;
    /* identical to box height, or 32px */
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.07em;
    /* blue */
    color: var(--hsrcDarkBlue);
    cursor: pointer;
}

.sublink {
    width: max-content;
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 1%;
    /* identical to box height, or 32px */
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.07em;
    /* blue */
    color: var(--hsrcDarkBlue);
    cursor: pointer;
}

.sublink:hover {
    text-decoration: none;
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 1.5%;
    /* identical to box height, or 32px */
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.07em;
    /* Orange */
    color: #FF7F50;
}

.link:hover {
    text-decoration: none;
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.5%;
    /* identical to box height, or 32px */
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.07em;
    /* Orange */
    color: #FF7F50;
}

.disabled_link {
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 1%;
    /* identical to box height, or 32px */
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.07em;
    /* blue */
    color: var(--hsrcDarkBlue);
}

.disabled_link:hover {
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.5%;
    /* identical to box height, or 32px */
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.07em;
    /* Orange */
    color: #FF7F50;
    cursor: not-allowed;
}

.question-label {
    font-family: var(--boldFontFamily);
    font-size: 24px;
    line-height: 32px;
    color: var(--hsrcDarkBlue);
    display: flex;
    align-items: center;
    letter-spacing: 0.07em;
    text-transform: capitalize;
}

.header {
    font-family: var(--FontFamily);
    font-size: 42px;
    font-weight: 700;
    line-height: 63px;
    letter-spacing: 0.07em;
    text-align: left;
    color: var(--hsrcDarkBlue);
}

.header__page {
    font-family: var(--boldFontFamily);
}

.input-text {
    width: 434px;
    height: 70px;
    font-size: 15px;
    padding-left: 20px;
    margin-right: 20px;
    border: none;
}

.input-text--rounded-corners {
    border-radius: 15px;
    border: 0.5px solid;
}

.input-text--bottom-border {
    border-bottom: 0.5px solid;
}

.input-date {
    width: 434px;
    height: 70px;
    font-size: 15px;
    padding-left: 20px;
    margin-right: 20px;
    border: none;
}

.input-date--rounded-corners {
    border-radius: 15px;
    border: 0.5px solid;
}

textarea:focus,
input:focus {
    outline: none;
}

input:hover {
    border-radius: 15px;
}

.input-textarea {
    height: 174px;
    width: 918px;
    border-radius: 15px;
    font-size: 15px;
    padding-left: 20px;
    margin-right: 20px;
}

.table>thead>tr>th,
.table>tbody>tr>th,
th {
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    text-align: center;
    vertical-align: middle;
    background-color: var(--hsrcYellow);
}

.col-1 {
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    width: 300px;
    height: 70px;
    text-align: center;
}

.col-2 {
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    width: 200px;
    height: 70px;
    text-align: center;
    background-color: var(--hsrcYellow);
}

.col-3 {
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    Width: 285px;
    height: 70px;
}

td {
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    height: 70px;
    border-right: 0.2px solid var(--hsrcLightDark);
    border-bottom: 0.2px solid var(--hsrcLightDark);
}

.col-date {
    font-family: var(--FontFamily);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    width: 198px;
    height: 70px;
}

.loading-overlay {
    display: none;
    /* background: rgba(255, 255, 255, 0.7); */
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 9999;
    align-items: center;
    justify-content: center;
}

.loading-overlay.is-active {
    display: flex;
}

.box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.boxItemActive {
  border-radius: 15px;
   width: 75px;
   height: 67px;
  font-size: 1.8rem;
  font-weight: bold;
  font-family: var(--bookFontFamily);
  line-height: 1;
  text-align: center;
  padding: 1rem;
  background: var(--hsrcOrange);
  border: 3px solid var(--hsrcOrange);;
  color: #fff;
  margin: 6px;
}

.boxItem {
  border-radius: 15px;
   width: 75px;
   height: 67px;
  font-size: 1.8rem;
  font-weight: bold;
  font-family: var(--bookFontFamily);
  line-height: 1;
  text-align: center;
  padding: 1rem;
  background: #fff;
  border: 3px solid #ccc;
  color: #ccc;
  margin: 6px;
}`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;;;;;;;;CAQC;;AAED;IACI,uBAAuB;IACvB,+DAA4D;AAChE;;AAEA;IACI,4BAA4B;IAC5B,+DAAiE;IACjE,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,+DAAiE;AACrE;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,gCAAgC;IAChC,oCAAoC;IACpC,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,8BAA8B;IAC9B,oBAAoB;IACpB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,+BAA+B;IAC/B,+BAA+B;IAC/B,8BAA8B;IAC9B,oDAAoD;IACpD,4CAA4C;IAC5C,6CAA6C;IAC7C,wCAAwC;IACxC,6CAA6C;IAC7C,gEAAgE;IAChE,iEAAiE;IACjE,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;;IAEI,8BAA8B;IAC9B,yBAAyB;IACzB,aAAa;AACjB;;AAEA;;GAEG;;AAEH;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,0BAA0B;AAC9B;;;AAGA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;IAC5B,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,wBAAwB;AAC5B;;;AAGA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,0BAA0B;IAC1B,WAAW;IACX,mBAAmB;IACnB,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;IACtC,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IAEb,gCAAgC;IAEhC,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,mCAAmC;IACnC,+BAA+B;IAC/B,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,4CAA4C;IAC5C,mBAAmB;IACnB,mBAAmB;IACnB,iCAAiC;IACjC,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;;IAEnB,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,sCAAsC;IACtC,eAAe;IACf,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;;AAE1B;;AAEA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,UAAU;IACV,qCAAqC;IACrC,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,oCAAoC;IACpC,sBAAsB;IACtB,kBAAkB;;IAElB,oDAAoD;IACpD,kBAAkB;IAClB,UAAU;;AAEd;;;AAGA,oEAAoE;;AAEpE;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,mBAAmB;IACnB,sCAAsC;IACtC,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;IAClB,iCAAiC;IACjC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,4CAA4C;IAC5C,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;;IAGI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,8CAA8C;IAC9C,+CAA+C;AACnD;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;GAClB,WAAW;GACX,YAAY;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,mCAAmC;EACnC,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;GAClB,WAAW;GACX,YAAY;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb","sourcesContent":["/*\r\n\r\n* This file contains the styling for R&D Questionnaires components\r\n\r\nThis files table contents are outlined below>>>>>\r\n\r\n*******************************************\r\n*******************************************\r\n*/\r\n\r\n@font-face {\r\n    font-family: \"FuturaLT\";\r\n    src: url(\"../assets/fonts/FuturaLT.woff\") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n    font-family: \"FuturaLT-Bold\";\r\n    src: url(\"../assets/fonts/FuturaLT-Bold.woff\") format(\"truetype\");\r\n    font-weight: bold;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"FuturaLT-Book\";\r\n    src: url(\"../assets/fonts/FuturaLT-Book.woff\") format(\"truetype\");\r\n}\r\n\r\n:root {\r\n    --hsrcDarkBlue: #133454;\r\n    --hsrcMidBlue: #415167;\r\n    --hsrcOrange: #FF7F50;\r\n    --hsrcYellow: hsl(41, 100%, 73%);\r\n    --hsrcDarkYellow: hsl(43, 100%, 73%);\r\n    --hsrcInactive: #A2A1B2;\r\n    --hsrcLightDark: #ECEFF4;\r\n    --hsrcHoverLight: #F8F7FE;\r\n    --hsrcBackgroundLight: #FCFCFC;\r\n    --hsrcWhite: #FFFFFF;\r\n    --hsrcHover: #A17FEF;\r\n    --hsrcMainRed: #FF3407;\r\n    --hsrcLightRed: #FFF7F5;\r\n    --hsrcMainGreen: #00BA88;\r\n    --hsrcMidGreen1: #E9FBE6;\r\n    --hsrcMidGreen2: #D7FAD1;\r\n    --hsrcMidGreen3: #BDF1BF;\r\n    --hsrcMidGreen: var(--hsrcMidGreen2);\r\n    --hsrcLightGreen: #F6FFF9;\r\n    --hsrcBlue: #669FF6;\r\n    --hsrcPurple: #7381EA;\r\n    --FontFamily: FuturaLT;\r\n    --boldFontFamily: FuturaLT-Bold;\r\n    --bookFontFamily: FuturaLT-Book;\r\n    --st-modal-borderRadius: 15 px;\r\n    --st-modal-boxShadow: 0 10px 50px rgba(0, 0, 0, 0.8);\r\n    --st-modal-backgroundColor: var(--hsrcWhite);\r\n    --st-modal-titleTextColor: var(--hsrcMidBlue);\r\n    --st-modal-secondColor: var(--hsrcWhite);\r\n    --st-dialog-contentColor: var(--hsrcDarkBlue);\r\n    --st-modal-transformVisible: translate3d(-50%, -50%, 0) scale(1);\r\n    --st-modal-transformHidden: translate3d(-50%, -50%, 0) scale(0.1);\r\n    --st-button-primaryColor: var(--hsrcOrange);\r\n    --st-button-primaryTextColor: var(--hsrcWhite);\r\n}\r\n\r\nhtml,\r\nbody {\r\n    font-family: var(--FontFamily);\r\n    color: var(--hsrcMidBlue);\r\n    height: 100vh;\r\n}\r\n\r\n/* a:link{\r\ncolor: var(--hsrcOrange);\r\n} */\r\n\r\n::-webkit-input-placeholder {\r\n    /* Chrome/Opera/Safari */\r\n    font-family: var(--FontFamily);\r\n    color: var(--hsrcInactive);\r\n}\r\n\r\n::-moz-placeholder {\r\n    /* Firefox 19+ */\r\n    font-family: var(--FontFamily);\r\n    color: var(--hsrcInactive);\r\n}\r\n\r\n:-ms-input-placeholder {\r\n    /* IE 10+ */\r\n    font-family: var(--FontFamily);\r\n    color: var(--hsrcInactive);\r\n}\r\n\r\n:-moz-placeholder {\r\n    /* Firefox 18- */\r\n    font-family: var(--FontFamily);\r\n    color: var(--hsrcInactive);\r\n}\r\n\r\n.title__54px {\r\n    font-size: 54px;\r\n    color: var(--hsrcDarkBlue);\r\n    letter-spacing: 0.07em;\r\n    text-transform: none;\r\n}\r\n\r\n.title__54px__orange {\r\n    font-size: 54px;\r\n    color: var(--hsrcOrange);\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: flex-start;\r\n    align-content: flex-start;\r\n    justify-content: flex-start;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.title__42px {\r\n    font-size: 42px;\r\n    color: var(--hsrcDarkBlue);\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.title__42px__orange {\r\n    color: var(--hsrcOrange);\r\n    font-size: 42px;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.title__42px__orange__bold {\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    color: var(--hsrcOrange);\r\n    font-size: 42px;\r\n    font-weight: bold;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.title__66px {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 66px;\r\n    line-height: 120%;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.title__32px {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 32px;\r\n    line-height: 42px;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.title__32px__orange {\r\n    color: var(--hsrcOrange);\r\n    font-size: 32px;\r\n    line-height: 42px;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.title__18px {\r\n    font-weight: bold;\r\n    font-size: 18px;\r\n    line-height: 200%;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n    color: var(--hsrcDarkBlue);\r\n}\r\n\r\n.title__24px {\r\n    font-weight: bold;\r\n    font-size: 24px;\r\n    line-height: 32px;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n    color: var(--hsrcDarkBlue);\r\n}\r\n\r\n.title__16px {\r\n    font-size: 16px;\r\n    line-height: 150%;\r\n    letter-spacing: 0.07em;\r\n    text-transform: none;\r\n    color: var(--hsrcDarkBlue);\r\n}\r\n\r\n\r\n.title__16px__instruction {\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    line-height: 150%;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n    color: var(--hsrcDarkYellow);\r\n    padding-left: 20px;\r\n}\r\n\r\n\r\n.title__16px__definition {\r\n    font-size: 16px;\r\n    line-height: 150%;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n    color: var(--hsrcOrange);\r\n}\r\n\r\n\r\n.title__16px__bold {\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-size: 16px;\r\n    line-height: 150%;\r\n    letter-spacing: 0.07em;\r\n    text-transform: none;\r\n    color: var(--hsrcDarkBlue);\r\n    font-weight: bold;\r\n}\r\n\r\n.title__18px__orange {\r\n    font-weight: bold;\r\n    font-size: 18px;\r\n    line-height: 200%;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n    color: var(--hsrcOrange);\r\n}\r\n\r\n.title__24px {\r\n    font-weight: bold;\r\n    font-size: 24px;\r\n    line-height: 32px;\r\n    letter-spacing: 0.07em;\r\n    text-transform: none;\r\n    color: var(--hsrcDarkBlue);\r\n}\r\n\r\n.title__24px__orange {\r\n    font-weight: bold;\r\n    font-size: 24px;\r\n    line-height: 32px;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n    color: var(--hsrcOrange);\r\n}\r\n\r\n.title__16px__orange {\r\n    font-size: 16px;\r\n    line-height: 150%;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n    color: var(--hsrcOrange);\r\n}\r\n\r\n.text__24px {\r\n    font-size: 24px;\r\n    letter-spacing: 0.07em;\r\n    color: var(--hsrcMidBlue);\r\n    line-height: 200%;\r\n}\r\n\r\n.text__18px {\r\n    font-size: 18px;\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    letter-spacing: 0.07em;\r\n    text-transform: none;\r\n    color: var(--hsrcMidBlue);\r\n}\r\n\r\n.text__18px__bold {\r\n    font-size: 18px;\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: bold;\r\n    letter-spacing: 0.07em;\r\n    color: var(--hsrcMidBlue);\r\n}\r\n\r\n.text__18px__border {\r\n    font-size: 18px;\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    letter-spacing: 0.07em;\r\n    color: var(--hsrcMidBlue);\r\n    border: 1px;\r\n    border-style: solid;\r\n    border-color: var(--hsrcOrange);\r\n    padding: 1em;\r\n}\r\n\r\n.text__18px__orange {\r\n    font-size: 18px;\r\n    font-weight: 400;\r\n    letter-spacing: 0.07em;\r\n    color: var(--hsrcOrange);\r\n}\r\n\r\n.text__18px__orange__bold {\r\n    font-size: 18px;\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: bold;\r\n    letter-spacing: 0.07em;\r\n    color: var(--hsrcOrange);\r\n}\r\n\r\n.text__12px {\r\n    font-size: 12px;\r\n    color: var(--hsrcMidBlue);\r\n}\r\n\r\n.text__16px {\r\n    font-family: var(--FontFamily);\r\n    font-size: 16px;\r\n    color: var(--hsrcDarkBlue);\r\n}\r\n\r\n.text__16px__border {\r\n    font-family: var(--FontFamily);\r\n    font-size: 16px;\r\n    color: var(--hsrcDarkBlue);\r\n    border: 1px;\r\n    border-style: solid;\r\n    border-color: var(--hsrcOrange);\r\n    padding: 1em;\r\n}\r\n\r\n.text__16px__orange {\r\n    font-family: var(--FontFamily);\r\n    font-size: 16px;\r\n    color: var(--hsrcOrange);\r\n}\r\n\r\n.text__14px {\r\n    font-size: 14px;\r\n    color: var(--hsrcMidBlue);\r\n}\r\n\r\n.text__14px__orange {\r\n    font-size: 14px;\r\n    color: var(--hsrcOrange);\r\n}\r\n\r\n.input__box {\r\n    width: 434px;\r\n    height: 70px;\r\n    border-radius: 16px;\r\n    background: var(--hsrcBackgroundLight);\r\n    color: var(--hsrcMidBlue);\r\n    font-size: 16px;\r\n    border-style: solid;\r\n    border-width: 1.5px;\r\n    border-color: var(--hsrcMidBlue);\r\n    padding: 20px;\r\n    -webkit-box-sizing: border-box;\r\n    /* Safari/Chrome, other WebKit */\r\n    -moz-box-sizing: border-box;\r\n    /* Firefox, other Gecko */\r\n    box-sizing: border-box;\r\n    /* Opera/IE 8+ */\r\n}\r\n\r\n.button__orange {\r\n    display: inline-block;\r\n    border-radius: 13px;\r\n    background-color: var(--hsrcOrange);\r\n    border-color: var(--hsrcOrange);\r\n    border-style: solid;\r\n    border-width: 1.5px;\r\n    color: var(--hsrcWhite);\r\n    text-align: center;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    transition: all 0.5s;\r\n    margin: 15px;\r\n    letter-spacing: 0.08rem;\r\n    cursor: pointer;\r\n    height: 70px;\r\n    width: auto;\r\n}\r\n\r\n.button {\r\n    display: inline-block;\r\n    border-radius: 13px;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-style: solid;\r\n    border-width: 1.5px;\r\n    border-color: var(--hsrcDarkBlue);\r\n    color: var(--hsrcDarkBlue);\r\n    text-align: center;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n\r\n    transition: all 0.5s;\r\n    margin: 15px;\r\n    letter-spacing: 0.08rem;\r\n    cursor: pointer;\r\n    height: 70px;\r\n    width: auto;\r\n}\r\n\r\na:link {\r\n    text-decoration: none;\r\n    font-family: var(--bookFontFamily);\r\n    color: var(--hsrcMidBlue);\r\n}\r\n\r\na:visited {\r\n    text-decoration: none;\r\n    color: var(--hsrcMidBlue);\r\n}\r\n\r\na:hover {\r\n    text-decoration: none;\r\n    font-family: var(--bookFontFamily);\r\n    color: var(--hsrcOrange);\r\n}\r\n\r\na:active {\r\n    text-decoration: none;\r\n}\r\n\r\n.btnNext {\r\n    background-color: var(--hsrcYellow);\r\n    /* Green */\r\n    border: none;\r\n    color: black;\r\n    font-size: 24px;\r\n    padding: 20px;\r\n    width: 200px;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n    margin: 15px 20px;\r\n    cursor: pointer;\r\n    border-radius: 8px;\r\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\r\n}\r\n\r\n.btnBack {\r\n    background-color: var( --hsrcDarkBlue);\r\n    font-size: 24px;\r\n    padding: 20px;\r\n    width: 200px;\r\n    border: none;\r\n    color: var(--hsrcWhite);\r\n    text-align: center;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n    margin: 15px 20px;\r\n    cursor: pointer;\r\n    border-radius: 8px;\r\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\r\n}\r\n\r\n.btnBack2 {\r\n    background-color: var( --hsrcDarkBlue);\r\n    font-size: 12px;\r\n    /* padding: 5px; */\r\n    min-width: 6rem;\r\n    border-radius: 0.5rem;\r\n    font-size: 0.8em;\r\n    min-height: 2rem;\r\n    border: none;\r\n    color: var(--hsrcWhite);\r\n    text-align: center;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n    margin: 5px 8px;\r\n    cursor: pointer;\r\n    /* border-radius: 12px; */\r\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\r\n}\r\n\r\n.btnFinish {\r\n    background-color: var(--hsrcYellow);\r\n    font-size: 24px;\r\n    padding: 20px;\r\n    width: 200px;\r\n    border: none;\r\n    color: black;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n    margin: 15px 20px;\r\n    cursor: pointer;\r\n    border-radius: 8px;\r\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\r\n}\r\n\r\n.question {\r\n    font-size: 24px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 32px;\r\n    letter-spacing: 0.07em;\r\n    text-align: left;\r\n}\r\n\r\n.belowTitleText {\r\n    font-family: var(--bookFontFamily);\r\n    color: var(--hsrcMidBlue);\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 36px;\r\n    letter-spacing: 0.07em;\r\n    text-align: left;\r\n}\r\n\r\n.partNumber {\r\n    font-family: var(--bookFontFamily);\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 25px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 63px;\r\n    letter-spacing: 0.07em;\r\n    text-align: left;\r\n}\r\n\r\n.partTitle {\r\n    font-family: var(--bookFontFamily);\r\n    font-size: 25px;\r\n    line-height: 63px;\r\n    letter-spacing: 0.07em;\r\n    text-align: left;\r\n}\r\n\r\n.pageHint {\r\n    font-family: var(--bookFontFamily);\r\n    margin-left: 30px;\r\n    font-size: 12px;\r\n    white-space: pre-wrap ; \r\n}\r\n\r\n.pageHint .pageHintText {\r\n    font-family: var(--bookFontFamily);\r\n    font-size: 12px;\r\n    visibility: hidden;\r\n    width: 120px;\r\n    background-color: black;\r\n    color: var(--hsrcWhite);\r\n    text-align: left;\r\n    padding: 5px 0;\r\n    border-radius: 6px;\r\n    white-space: pre-wrap ; \r\n\r\n}\r\n\r\n/* Tooltip text */\r\n\r\n.pageHint .tooltiptext {\r\n    visibility: hidden;\r\n    width: 20%;\r\n    background-color: var(--hsrcLightRed);\r\n    color: var(--hsrcMainRed);\r\n    text-align:left;\r\n    margin-left: 20px;\r\n    padding: 10px;\r\n    border: 1px solid var(--hsrcMainRed);\r\n    box-sizing: border-box;\r\n    border-radius: 5px;\r\n    \r\n    /* Position the tooltip text - see examples below! */\r\n    position: absolute;\r\n    z-index: 1; \r\n\r\n}\r\n\r\n\r\n/* Show the tooltip text when you mouse over the tooltip container */\r\n\r\n.pageHint:hover .tooltiptext {\r\n    visibility: visible;\r\n}\r\n\r\n.inputRandSign {\r\n    position: start;\r\n    text-align: left;\r\n    align-content: center;\r\n}\r\n\r\n.input-text--rounded-corners {\r\n    font-family: var(--bookFontFamily);\r\n    border-radius: 15px;\r\n    border: 0.5px solid;\r\n    background: var(--hsrcBackgroundLight);\r\n    color: var(--hsrcMidBlue);\r\n    font-size: 16px;\r\n    border-style: solid;\r\n    border-width: 1.5px;\r\n    border-color: var(--hsrcMidBlue);\r\n}\r\n\r\ninput.radio {\r\n    width: 16px;\r\n    height: 16px;\r\n    margin: 10px;\r\n}\r\n\r\ninput[type=\"radio\"]:checked+label {\r\n    font-family: Futura LT;\r\n    font-size: 18px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 36px;\r\n    letter-spacing: 0.07em;\r\n    text-align: left;\r\n}\r\n\r\ninput[type='radio']:after {\r\n    width: 15px;\r\n    height: 15px;\r\n    border-radius: 15px;\r\n    top: -2px;\r\n    left: -1px;\r\n    position: relative;\r\n    background-color: #d1d3d1;\r\n    content: '';\r\n    display: inline-block;\r\n    visibility: visible;\r\n    border: 2px solid white;\r\n}\r\n\r\ninput[type='radio']:checked:after {\r\n    width: 15px;\r\n    height: 15px;\r\n    border-radius: 15px;\r\n    top: -2px;\r\n    left: -1px;\r\n    position: relative;\r\n    content: '';\r\n    display: inline-block;\r\n    visibility: visible;\r\n    border: 4px solid #07BC85;\r\n}\r\n\r\n.b2 {\r\n    width: 800px;\r\n}\r\n\r\nh2 {\r\n    font-family: var(--bookFontFamily);\r\n    font-size: 24px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 32px;\r\n    letter-spacing: 0.07em;\r\n    text-align: left;\r\n}\r\n\r\nh5 {\r\n    font-family: var(--bookFontFamily);\r\n    font-size: 15px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 32px;\r\n    letter-spacing: 0.07em;\r\n    text-align: left;\r\n}\r\n\r\ninput[type='text'] {\r\n    border-style: none none solid none;\r\n    border-collapse: collapse;\r\n    border-radius: 0px;\r\n    border-color: var(--hsrcInactive);\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\ninput[type='number'] {\r\n    border-style: none;\r\n    border-collapse: collapse;\r\n    border-radius: 0px;\r\n    border-color: var(--hsrcWhite);\r\n    width: 100px;\r\n    height: 100%;\r\n}\r\n\r\ninput[type='radio']:after {\r\n    width: 15px;\r\n    height: 15px;\r\n    border-radius: 15px;\r\n    top: -2px;\r\n    left: -1px;\r\n    position: relative;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    content: '';\r\n    display: inline-block;\r\n    visibility: visible;\r\n    border: 2px solid var(--hsrcWhite);\r\n}\r\n\r\ninput[type='radio']:checked:after {\r\n    width: 15px;\r\n    height: 15px;\r\n    border-radius: 15px;\r\n    top: -2px;\r\n    left: -1px;\r\n    position: relative;\r\n    content: '';\r\n    display: inline-block;\r\n    visibility: visible;\r\n    border: 4px solid var(--hsrcMainGreen);\r\n}\r\n\r\n.link {\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 16px;\r\n    line-height: 1%;\r\n    /* identical to box height, or 32px */\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.07em;\r\n    /* blue */\r\n    color: var(--hsrcDarkBlue);\r\n    cursor: pointer;\r\n}\r\n\r\n.sublink {\r\n    width: max-content;\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 14px;\r\n    line-height: 1%;\r\n    /* identical to box height, or 32px */\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.07em;\r\n    /* blue */\r\n    color: var(--hsrcDarkBlue);\r\n    cursor: pointer;\r\n}\r\n\r\n.sublink:hover {\r\n    text-decoration: none;\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: bold;\r\n    font-size: 14px;\r\n    line-height: 1.5%;\r\n    /* identical to box height, or 32px */\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.07em;\r\n    /* Orange */\r\n    color: #FF7F50;\r\n}\r\n\r\n.link:hover {\r\n    text-decoration: none;\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    line-height: 1.5%;\r\n    /* identical to box height, or 32px */\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.07em;\r\n    /* Orange */\r\n    color: #FF7F50;\r\n}\r\n\r\n.disabled_link {\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 16px;\r\n    line-height: 1%;\r\n    /* identical to box height, or 32px */\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.07em;\r\n    /* blue */\r\n    color: var(--hsrcDarkBlue);\r\n}\r\n\r\n.disabled_link:hover {\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    line-height: 1.5%;\r\n    /* identical to box height, or 32px */\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.07em;\r\n    /* Orange */\r\n    color: #FF7F50;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.question-label {\r\n    font-family: var(--boldFontFamily);\r\n    font-size: 24px;\r\n    line-height: 32px;\r\n    color: var(--hsrcDarkBlue);\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.header {\r\n    font-family: var(--FontFamily);\r\n    font-size: 42px;\r\n    font-weight: 700;\r\n    line-height: 63px;\r\n    letter-spacing: 0.07em;\r\n    text-align: left;\r\n    color: var(--hsrcDarkBlue);\r\n}\r\n\r\n.header__page {\r\n    font-family: var(--boldFontFamily);\r\n}\r\n\r\n.input-text {\r\n    width: 434px;\r\n    height: 70px;\r\n    font-size: 15px;\r\n    padding-left: 20px;\r\n    margin-right: 20px;\r\n    border: none;\r\n}\r\n\r\n.input-text--rounded-corners {\r\n    border-radius: 15px;\r\n    border: 0.5px solid;\r\n}\r\n\r\n.input-text--bottom-border {\r\n    border-bottom: 0.5px solid;\r\n}\r\n\r\n.input-date {\r\n    width: 434px;\r\n    height: 70px;\r\n    font-size: 15px;\r\n    padding-left: 20px;\r\n    margin-right: 20px;\r\n    border: none;\r\n}\r\n\r\n.input-date--rounded-corners {\r\n    border-radius: 15px;\r\n    border: 0.5px solid;\r\n}\r\n\r\ntextarea:focus,\r\ninput:focus {\r\n    outline: none;\r\n}\r\n\r\ninput:hover {\r\n    border-radius: 15px;\r\n}\r\n\r\n.input-textarea {\r\n    height: 174px;\r\n    width: 918px;\r\n    border-radius: 15px;\r\n    font-size: 15px;\r\n    padding-left: 20px;\r\n    margin-right: 20px;\r\n}\r\n\r\n.table>thead>tr>th,\r\n.table>tbody>tr>th,\r\nth {\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 18px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    background-color: var(--hsrcYellow);\r\n}\r\n\r\n.col-1 {\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 16px;\r\n    width: 300px;\r\n    height: 70px;\r\n    text-align: center;\r\n}\r\n\r\n.col-2 {\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 16px;\r\n    width: 200px;\r\n    height: 70px;\r\n    text-align: center;\r\n    background-color: var(--hsrcYellow);\r\n}\r\n\r\n.col-3 {\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 16px;\r\n    Width: 285px;\r\n    height: 70px;\r\n}\r\n\r\ntd {\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 16px;\r\n    height: 70px;\r\n    border-right: 0.2px solid var(--hsrcLightDark);\r\n    border-bottom: 0.2px solid var(--hsrcLightDark);\r\n}\r\n\r\n.col-date {\r\n    font-family: var(--FontFamily);\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 16px;\r\n    width: 198px;\r\n    height: 70px;\r\n}\r\n\r\n.loading-overlay {\r\n    display: none;\r\n    /* background: rgba(255, 255, 255, 0.7); */\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    z-index: 9999;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.loading-overlay.is-active {\r\n    display: flex;\r\n}\r\n\r\n.box {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n}\r\n.boxItemActive {\r\n  border-radius: 15px;\r\n   width: 75px;\r\n   height: 67px;\r\n  font-size: 1.8rem;\r\n  font-weight: bold;\r\n  font-family: var(--bookFontFamily);\r\n  line-height: 1;\r\n  text-align: center;\r\n  padding: 1rem;\r\n  background: var(--hsrcOrange);\r\n  border: 3px solid var(--hsrcOrange);;\r\n  color: #fff;\r\n  margin: 6px;\r\n}\r\n\r\n.boxItem {\r\n  border-radius: 15px;\r\n   width: 75px;\r\n   height: 67px;\r\n  font-size: 1.8rem;\r\n  font-weight: bold;\r\n  font-family: var(--bookFontFamily);\r\n  line-height: 1;\r\n  text-align: center;\r\n  padding: 1rem;\r\n  background: #fff;\r\n  border: 3px solid #ccc;\r\n  color: #ccc;\r\n  margin: 6px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
